import React, { use } from "react";
import { useSelector } from "react-redux";
import { getContentHeight } from "../../../../utils/textUtils";
import { typeInfo } from "../../../../constants/typeInfo";

const ParagraphSelector = ({
  paragraphList,
  selectedParagraph,
  setSelectedParagraph,
  handleNext,
  isPreview = false,
  isReview = false,
}) => {
  const { assignment } = useSelector((state) => state.assignment);
  const { mode } = useSelector((state) => state.ui);

  const isMobile = mode === "mobile";

  return (
    <div
      style={{
        backgroundColor: "#FFF",
        height: getContentHeight(isMobile),
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          textAlign: "center",
          paddingTop: isMobile ? "10px" : "30px",
          fontSize: isMobile ? "14px" : "24px",
        }}
      >
        학습할 지문을 선택해주세요.
      </div>
      <div
        style={{
          textAlign: "center",
          paddingTop: assignment?.type != "vocabulary" && "5px",
          paddingBottom:
            assignment?.type != "vocabulary" && (isMobile ? "10px" : "30px"),
          fontSize: isMobile ? "12px" : "18px",
          color: "#FF4444",
        }}
      >
        전체 지문을 다 학습하셔야 학습완료 처리됩니다. 학습 마감일까지 미완성시
        알림톡이 발송됩니다.
      </div>
      {assignment?.type == "vocabulary" && (
        <div
          style={{
            textAlign: "center",
            fontWeight: "bold",
            paddingBottom: isMobile ? "10px" : "30px",
            fontSize: isMobile ? "12px" : "18px",
            color: "#FF4444",
          }}
        >
          단어장, 매칭게임은 지속적인 학습을 위해, 진행해도 완료 처리되지
          않습니다.
        </div>
      )}
      <div
        style={{
          flex: "1", // 남은 공간을 차지
          overflowY: "auto", // 스크롤 활성화
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: isMobile ? "10px" : "20px",
          }}
        >
          {paragraphList.length > 0 &&
            paragraphList
              .slice()
              .sort((a, b) => {
                if (a.is_finished && !b.is_finished) return 1;
                if (!a.is_finished && b.is_finished) return -1;
                return 0;
              })
              .map((paragraph) => (
                <div
                  key={paragraph.id}
                  style={{
                    display: "flex",
                    width: "70%",
                    margin: "0 auto",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: isMobile ? "10px" : "20px",
                    fontWeight: "bold",
                    fontSize: isMobile ? "12px" : "16px",
                    border:
                      "1px solid " +
                      (selectedParagraph?.id === paragraph.id
                        ? typeInfo[assignment.type]?.color
                        : "#EBEBEB"),
                    borderRadius: "5px",
                    backgroundColor:
                      !isReview && !isPreview && paragraph.is_finished
                        ? "#EBEBEB"
                        : selectedParagraph?.id === paragraph.id &&
                          typeInfo[assignment.type]?.backgroundColor,
                    cursor:
                      !isReview && !isPreview && paragraph.is_finished
                        ? "not-allowed"
                        : "pointer",
                    color: "#737373",
                  }}
                  onClick={
                    !isReview && !isPreview && paragraph.is_finished
                      ? null
                      : () => setSelectedParagraph(paragraph)
                  }
                >
                  {paragraph.title}
                </div>
              ))}
        </div>
      </div>
      <div style={{ textAlign: "right", padding: isMobile ? "0px" : "20px" }}>
        <button
          style={{
            backgroundColor: "#000000",
            color: "#FFFFFF",
            border: "none",
            borderRadius: "5px",
            padding: "5px 50px",
            cursor: "pointer",
            fontSize: isMobile ? "14px" : "18px",
            margin: isMobile ? "10px" : "20px",
          }}
          onClick={() => handleNext()}
        >
          다음
        </button>
      </div>
    </div>
  );
};

export default ParagraphSelector;
